
import TaoReady from './Ready';

const maxToasts = 3;

/**
 * Simple Custom Toast Class to generate toasts
 *
 * @param containerId Append the Toaster instance to the given container.
 */
class TaoToaster {
	constructor( containerId ) {
		TaoReady.ready( 'tao-toaster', () => {
			this.containerEl = document.getElementById( containerId );

			if ( ! this.containerEl ) {
				this.containerEl = document.createElement( 'div' );
				this.containerEl.id = containerId;
				this.containerEl.classList.add( 'mdl_toaster' );

				document.body.appendChild( this.containerEl );
			}
		} );
	}

	/**
	 * Send toast to container.
	 *
	 * @param {string} text    Test to show.
	 * @param {string} color   The color of the toast.
	 * @param {Object} options Other Options, like timeout.
	 * @return {Promise}       Promise that resolves to the notificationEl.
	 */
	toast( text, color = 'green', options = {} ) {
		if ( ! this.containerEl ) {
			console.error( 'TaoToaster could not send message: Container not found!' ); // eslint-disable-line no-console
			return false;
		}

		const settings = {
			closeable: true,
			timeout: 5000,
			...options,
		};

		const notificationEl = document.createElement( 'div' );
		notificationEl.classList.add( 'notification', color );
		notificationEl.role = 'alert';

		notificationEl.innerHTML = `
			<p>${ text }</p>
			${ settings.closeable ? '<button type="button" class="en_icon notification_close" data-en-icon="close" aria-label="Nachricht schließen"></button>' : '' }
		`;

		if ( this.containerEl.children.length >= maxToasts ) {
			this.containerEl.querySelectorAll( '.notification' ).forEach( ( node, index ) => {
				if ( index >= maxToasts - 1 ) {
					if ( node.parentElement ) {
						this.containerEl.removeChild( node );
					}
				}
			} );
		}

		this.containerEl.prepend( notificationEl );

		if ( settings.timeout ) {
			setTimeout( () => {
				if ( notificationEl.parentElement ) {
					this.containerEl.removeChild( notificationEl );
				}
			}, settings.timeout );
		}

		return notificationEl;
	}

	/**
	 * Clear all toasts.
	 *
	 * @return {Promise} Promise that resolves to the Container.
	 */
	clear() {
		if ( ! this.containerEl ) {
			console.error( 'TaoToaster could not clear messages: Container not found!' ); // eslint-disable-line no-console
			return false;
		}
		this.containerEl.innerHTML = '';
		return this.containerEl;
	}
}

export default new TaoToaster( 'tao-toaster' );
